import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {withTrackFont} from '../../../containers/DataContainer/siteSettings/withTrackFont';
import {withoutSize} from '../../../services/env/siteSettings/fonts/fonts';
import styles from './Subtitle.scss';

const SubtitleComponent = ({trackFont, className, children, dataHook}) => {
  const subtitleStyle = withoutSize(trackFont);
  return (
    <h4
      className={classNames([styles.subtitle, className])}
      style={subtitleStyle}
      data-hook={dataHook}
      title={typeof children === 'string' ? children : undefined}
    >
      {children}
    </h4>
  );
};

SubtitleComponent.propTypes = {
  trackFont: PropTypes.object,
  dataHook: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

SubtitleComponent.defaultProps = {
  dataHook: 'subtitle-header',
};

export const Subtitle = withTrackFont(SubtitleComponent);
